import type {
  PremadeCharacter,
  PremadeSourceContractWithRuleset,
} from "@dndbeyond/character-rules-engine";

/**
 * Returns the primary source of a premade character, or a "Not Sourced"
 * placeholder (with an "Unknown" ruleset) when it has none.
 */
export const getPrimarySource = (
  character: PremadeCharacter
): PremadeSourceContractWithRuleset => {
  return (
    character.sources.find((source) => source.isPrimary) || {
      sourceName: "Not Sourced",
      sourceId: 0,
      displayOrder: 9999,
      isPrimary: true,
      rulesetId: 0,
      rulesetDisplayLabel: "Unknown",
      rulesetName: "Unknown",
    }
  );
};
